import React from 'react'

const EmptyCart = () => {
  return (
    <svg height="15rem" width="20rem" x="0px" y="0px" viewBox="0 0 245 188">
      <line
        fill="#464646"
        stroke="#eaeaea"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="71.455"
        y1="165.089"
        x2="192.844"
        y2="165.089"
      />
      <path
        fill="#f5f5f5"
        d="M216.727,132.641L48.052,120.447c-2.056-0.149-3.602-1.936-3.453-3.992l6.549-90.6 c0.149-2.056,1.936-3.602,3.992-3.453l168.675,12.193c2.056,0.149,3.602,1.936,3.453,3.992l-6.549,90.6 C220.57,131.243,218.783,132.789,216.727,132.641z"
      />
      <ellipse
        transform="matrix(0.9978 -0.0658 0.0658 0.9978 -7.691 8.2899)"
        fill="#fff"
        stroke="#c9c9c9"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        cx="122.079"
        cy="120.972"
        rx="56.622"
        ry="56.622"
      />
      <ellipse
        transform="matrix(0.9978 -0.0658 0.0658 0.9978 -1.8699 11.8092)"
        fill="#fff"
        stroke="#c9c9c9"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        cx="178.449"
        cy="34.309"
        rx="24.308"
        ry="24.308"
      />
      <ellipse
        transform="matrix(0.9978 -0.0658 0.0658 0.9978 -7.691 8.2899)"
        fill="#e1e2e3"
        cx="122.079"
        cy="120.972"
        rx="44.116"
        ry="44.116"
      />
      <ellipse
        transform="matrix(0.9978 -0.0658 0.0658 0.9978 -1.8709 11.7787)"
        fill="#dbdcdd"
        cx="177.984"
        cy="34.309"
        rx="14.859"
        ry="14.859"
      />
      <line
        fill="none"
        stroke="#cfcfcf"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="101.063"
        y1="142.031"
        x2="111.25"
        y2="129.708"
      />
      <line
        fill="none"
        stroke="#cfcfcf"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="100.04"
        y1="126.498"
        x2="106.806"
        y2="117.905"
      />
      <line
        fill="none"
        stroke="#cfcfcf"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="93.493"
        y1="119.88"
        x2="100.259"
        y2="111.288"
      />
      <line
        fill="#464646"
        stroke="#fff"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="112.111"
        y1="128.837"
        x2="115.494"
        y2="124.541"
      />
      <line
        fill="#464646"
        stroke="#fff"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="106.435"
        y1="149.374"
        x2="116.793"
        y2="136.189"
      />
      <line
        fill="#464646"
        stroke="#fff"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="96.533"
        y1="147.463"
        x2="103.299"
        y2="138.87"
      />
      <line
        fill="#464646"
        stroke="#fff"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="91.062"
        y1="138.616"
        x2="104.551"
        y2="120.781"
      />
      <line
        fill="#464646"
        stroke="#fff"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="86.728"
        y1="128.473"
        x2="93.493"
        y2="119.88"
      />
      <path
        fill="#fff"
        d="M118.151,87.414L118.151,87.414l-7.928,5.705l0.156,0.682c-2.005,2.087-2.971,4.953-2.319,7.798  c0.823,3.594,3.979,6.1,7.731,6.556l4.934,1.195c0.828,0.284,1.692,0.496,2.581,0.625l0.013,0.003l0-0.001 c1.763,0.255,3.624,0.194,5.496-0.234c7.448-1.706,12.229-8.576,10.679-15.344c-1.55-6.769-8.845-10.873-16.293-9.167 C121.329,85.661,119.627,86.417,118.151,87.414z"
      />
      <line
        fill="none"
        stroke="#cfcfcf"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="85.806"
        y1="114.491"
        x2="92.572"
        y2="105.898"
      />
      <line
        fill="#464646"
        stroke="#fff"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="90.971"
        y1="107.727"
        x2="101.61"
        y2="94.701"
      />
      <ellipse
        transform="matrix(0.9978 -0.0658 0.0658 0.9978 -6.1314 8.5654)"
        fill="none"
        stroke="#eaeaea"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        cx="127.045"
        cy="97.419"
        rx="5.44"
        ry="5.44"
      />
      <line
        fill="#464646"
        stroke="#e8e8e8"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1={10}
        y1="87.846"
        x2="125.988"
        y2="39.952"
      />
      <line
        fill="#464646"
        stroke="#e8e8e8"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="12.984"
        y1="94.287"
        x2="128.972"
        y2="46.392"
      />
      <rect
        x="131.383"
        y="126.172"
        transform="matrix(0.8169 0.5768 -0.5768 0.8169 106.0643 -53.8047)"
        fill="none"
        stroke="#c9c9c9"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        width="12.767"
        height="27.922"
      />
      <polygon
        fill="#e1e2e3"
        stroke="#c9c9c9"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        points="134.875,136.109 127.726,125.53 150.86,109.896 158.009,120.474 "
      />
      <ellipse
        transform="matrix(0.9978 -0.0658 0.0658 0.9978 -7.636 2.7278)"
        fill="none"
        stroke="#eaeaea"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        cx="37.618"
        cy="117.356"
        rx="7.819"
        ry="7.819"
      />
      <path
        fill="#dddedf"
        d="M63.732,52.293l-40.911-7.601c-1.614-0.3-2.68-1.851-2.38-3.466l2.824-15.199 c0.3-1.614,1.851-2.68,3.466-2.38l40.911,7.601c1.614,0.3,2.68,1.851,2.38,3.466l-2.824,15.199 C66.898,51.527,65.346,52.593,63.732,52.293z"
      />
      <line
        fill="none"
        stroke="#ececec"
        strokeWidth="4.8775"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="29.798"
        y1="46.215"
        x2="33.644"
        y2="25.158"
      />
      <line
        fill="none"
        stroke="#ececec"
        strokeWidth="4.8775"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="39.354"
        y1="48.498"
        x2="43.199"
        y2="27.442"
      />
      <line
        fill="none"
        stroke="#ececec"
        strokeWidth="4.8775"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="48.909"
        y1="49.563"
        x2="52.755"
        y2="28.506"
      />
      <line
        fill="none"
        stroke="#ececec"
        strokeWidth="4.8775"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="58.465"
        y1="51.846"
        x2="62.31"
        y2="30.789"
      />
      <circle fill="#eaeaea" cx="48.883" cy="140.16" r="3.631" />
      <circle fill="#eaeaea" cx="200.121" cy="96.085" r="3.631" />
      <line
        fill="#464646"
        stroke="#eaeaea"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="204.456"
        y1="77.307"
        x2={235}
        y2="77.307"
      />
      <line
        fill="#464646"
        stroke="#eaeaea"
        strokeWidth="4.8775"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        x1="184.849"
        y1="151.705"
        x2="200.121"
        y2="151.705"
      />
    </svg>
  )
}

export default EmptyCart
